import React from "react";
import Register from "../components/Register/Register";

function Signup() {
  return (
    <div>
        <Register />
    </div>
  );
}

export default Signup;
